module.exports = "images/service_icon_01.svg";